/* eslint-disable consistent-return */
import { BsX } from '@react-icons/all-files/bs/BsX';
import React from 'react';
import { enableScrolling, preventScrolling } from '@/util/helper/scrolling';
import useEffect from '@/util/hook/useEffect';
import { ANIMATION_TYPE_MAP } from '@/config/ui/animation';
import { Z_INDEX } from '@/config/ui/zIndex';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
import { S } from './style';
import Animation from '../../helper/Animation';
const renderProgress = ({ currentProgress, totalProgress, }) => (<S.HeaderProgress max={totalProgress} value={currentProgress}>
    <div />
  </S.HeaderProgress>);
const renderCloseButton = ({ closePopup }) => (<S.PopupHeaderCloseButton onClick={closePopup}>
    <BsX style={{ fontSize: '30px', color: SEMANTIC_COLORS.DEFAULT_TEXT, margin: 0 }}/>
  </S.PopupHeaderCloseButton>);
/**
 * #NOTES
 * Prevent scrolling only when 'isSlideIn' is true to make the page scrollable
 * since this component will always be mounted on the page.
 */
const usePreventScrollingWhenSlideIn = ({ isSlideIn }) => {
    const scrollPosition = window.scrollY;
    useEffect(() => {
        if (!isSlideIn)
            return;
        preventScrolling({ scrollPosition });
        return () => {
            if (!isSlideIn)
                return;
            enableScrolling({ scrollPosition });
        };
    }, [isSlideIn]);
};
export default function Popup({ isSlideIn, // If 'isSlideIn' is true, PopupBody will slide in, else slide out and be unmounted.
closePopup, height, title, popupBody = null, popupFooter = null, isRenderCloseBtn = false, currentProgress, totalProgress, onSlideOut, // functions to be called when the popup slides out
 }) {
    usePreventScrollingWhenSlideIn({ isSlideIn });
    const isRenderProgress = Boolean(currentProgress && totalProgress);
    const OVERLAY_STYLE = `position: fixed; width: 100vw; height: 100vh; left: 0; bottom: 0; z-index: ${Z_INDEX.POPUP};`;
    const POPUP_BODY_STYLE = `position: fixed; width: inherit; max-width: inherit; height: ${height}; bottom: 0; z-index: ${Z_INDEX.POPUP}`;
    return (<>
      <Animation isShow={isSlideIn} customStyle={OVERLAY_STYLE} animationType={ANIMATION_TYPE_MAP.FADE_IN_OUT}>
        <S.Overlay onClick={closePopup}/>
      </Animation>
      <Animation isShow={isSlideIn} customStyle={POPUP_BODY_STYLE} animationType={ANIMATION_TYPE_MAP.SLIDE_IN_OUT} onAnimationEndExtraHandler={onSlideOut}>
        <S.LayoutPopup height='100%' onClick={(e) => e.stopPropagation()}>
          <S.PopupHeader isRenderProgress={isRenderProgress}>
            {isRenderProgress ? renderProgress({ currentProgress, totalProgress }) : null}
            <S.PopupHeaderTitle>{title}</S.PopupHeaderTitle>
            {isRenderCloseBtn ? renderCloseButton({ closePopup }) : null}
          </S.PopupHeader>
          {popupBody}
          {popupFooter}
        </S.LayoutPopup>
      </Animation>
    </>);
}
